import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=ea925398&scoped=true&"
import script from "./CreateNews.vue?vue&type=script&lang=js&"
export * from "./CreateNews.vue?vue&type=script&lang=js&"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=ea925398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea925398",
  null
  
)

export default component.exports